import { get } from "@/services/axiosUitils";

interface PreviousHoursManagementParams {
  employee_id: string;
  date?: string; // Format: YYYY-MM-DD
  hours?: number | string;
  minutes?: number | string;
  /** When updating, pass the spent hours record ID so validation excludes this record */
  spent_hours_id?: string;
}

interface PreviousHoursManagementResponse {
  success: {
    code: string;
    message: string;
  };
  employee_id: string;
  last_attendance_date: string;
  attendance_working_hours: string;
  spent_hours: string;
  spent_hours_entries_count: number;
  difference_hours: string;
  difference_total_minutes: number;
  is_valid: boolean;
  message: string;
}

class PtsSpentHoursService {
  /**
   * Check previous hours management validation
   * Calls: /pts_app/previous-hours-management/?employee_id={employee_id}&date={date}&hours={hours}&minutes={minutes}
   * @param params - Query parameters
   * @param params.employee_id - Employee ID
   * @param params.date - Date in YYYY-MM-DD format
   * @param params.hours - Hours value
   * @param params.minutes - Minutes value
   * @returns Previous hours management validation response
   */
  checkPreviousHoursValidation = async (
    params: PreviousHoursManagementParams
  ): Promise<PreviousHoursManagementResponse> => {
    if (!params.employee_id) {
      throw new Error("Employee ID is required");
    }

    const queryParams: any = {
      employee_id: params.employee_id,
    };

    // Add optional parameters if provided
    if (params.date) {
      queryParams.date = params.date;
    }
    if (params.hours !== undefined && params.hours !== null) {
      queryParams.hours = params.hours;
    }
    if (params.minutes !== undefined && params.minutes !== null) {
      queryParams.minutes = params.minutes;
    }
    if (params.spent_hours_id) {
      queryParams.spent_hours_id = params.spent_hours_id;
    }

    return await get<PreviousHoursManagementResponse>(
      "/pts_app/previous-hours-management/",
      {
        params: queryParams,
      }
    );
  };
}

const instance = new PtsSpentHoursService();
export default instance;
